export default function ComponentPhoto({ component }) {
    // Get the first photo from the component
    const photo = component.attachments.find(
        (attachment) => attachment.category === 'product_photo'
    )

    if (!photo) {
        return null
    }

    return (
        <div className="aspect-square border rounded-xl bg-white overflow-hidden">
            <img
                src={`https://baltic-supabase.b-cdn.net/public/attachements/${photo.file}?width=800`}
                alt="Photo du composant"
                className="w-full h-full object-cover"
            />
        </div>
    )
}
